(function () {
  'use strict';
  function update(root, id) {
    root.querySelectorAll('[data-case-unit-price]').forEach(function (note) {
      var entry = note.getAttribute('data-case-prices').split('|').find(function (item) {
        return item.slice(0, item.indexOf(':')) === String(id);
      });
      note.hidden = !entry;
      if (entry) note.textContent = entry.slice(entry.indexOf(':') + 1) + '/Each';
    });
  }
  function initialize(scope) {
    scope.querySelectorAll('[data-section-type="product-template"]').forEach(function (root) {
      if (root.hasAttribute('data-case-pricing-ready') || !root.querySelector('[data-case-unit-price]')) return;
      root.setAttribute('data-case-pricing-ready', '');
      root.addEventListener('product:variant:change', function (event) { update(root, event.detail.variantId); });
    });
  }
  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-quick-view-variant]')) return;
    var root = event.target.closest('[data-quick-view-product]');
    if (root) update(root, event.target.value);
  });
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  else initialize(document);
})();
